import axios from 'axios';

const instance = axios.create({
baseURL:'https://inkista-e-commerce-web-aq4i-server-testing.vercel.app'
});

export default instance;

// baseURL:     'http://localhost:8000'
// https://inkista-e-commerce-web-aq4i-server-testing.vercel.app